function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import digitalData from 'digital-data';
import { getState, setState } from '../analytics-state.js';
import { formatCarPickerString } from '../thd-analytics-utils.js';
export const carPicker = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('car-picker.dropdown-item-click', _ref => {
    var _getState, _data, _data2, _data3, _data4, _data5, _data6, _data7, _data8;
    let {
      output
    } = _ref;
    const {
      year,
      yearIndex,
      make,
      makeIndex,
      model,
      modelIndex
    } = output || {};
    const {
      currentPage,
      pageType,
      sortBy
    } = getState();
    let {
      data,
      formattedIndexes,
      formattedYearMakeModel,
      formattedYearMakeModelAlt
    } = ((_getState = getState()) === null || _getState === void 0 ? void 0 : _getState.automotive) || {};

    // If year is selected, we need to clear make and model
    // If make is selected, we need to clear model
    if (year) {
      data = _objectSpread(_objectSpread({}, data), {}, {
        make: '',
        makeIndex: 'default',
        model: '',
        modelIndex: 'default'
      });
    }
    if (make) {
      data = _objectSpread(_objectSpread({}, data), {}, {
        model: '',
        modelIndex: 'default'
      });
    }
    data = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, data), year && {
      year: year.value,
      yearIndex
    }), make && {
      make: make.value,
      makeIndex
    }), model && {
      model: model.value,
      modelIndex
    });
    formattedYearMakeModel = formatCarPickerString([(_data = data) === null || _data === void 0 ? void 0 : _data.year, (_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.make, (_data3 = data) === null || _data3 === void 0 ? void 0 : _data3.model], ' ');
    formattedYearMakeModelAlt = formatCarPickerString([(_data4 = data) === null || _data4 === void 0 ? void 0 : _data4.year, (_data5 = data) === null || _data5 === void 0 ? void 0 : _data5.make, (_data6 = data) === null || _data6 === void 0 ? void 0 : _data6.model], '>');
    formattedIndexes = formatCarPickerString([(_data7 = data) === null || _data7 === void 0 ? void 0 : _data7.yearIndex, (_data8 = data) === null || _data8 === void 0 ? void 0 : _data8.makeIndex, data.modelIndex], ':');
    setState({
      automotive: {
        data,
        formattedIndexes,
        formattedYearMakeModel,
        formattedYearMakeModelAlt
      }
    });
    const ddoEvent = {
      eventInfo: {
        eventName: 'filter by'
      },
      category: {
        primaryCategory: pageType
      },
      filter: [{
        selectionMethod: 'default',
        type: 'vehicle',
        value: formattedYearMakeModel,
        position: formattedIndexes
      }],
      displayAttributes: {
        viewType: 'grid',
        pageNumber: currentPage,
        productsAvailability: 'all products',
        sortBy
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });
  window.LIFE_CYCLE_EVENT_BUS.on('car-picker.select-vehicle-click', () => {
    var _getState2;
    const {
      formattedYearMakeModelAlt
    } = ((_getState2 = getState()) === null || _getState2 === void 0 ? void 0 : _getState2.automotive) || {};
    const ddoEvent = {
      category: {
        primaryCategory: 'stash'
      },
      eventInfo: {
        eventName: 'widget interaction'
      },
      eventMode: 'stash',
      content: {
        widget: {
          type: 'auto',
          value: formattedYearMakeModelAlt
        }
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });
  window.LIFE_CYCLE_EVENT_BUS.on('car-picker.shop-universal-parts', () => {
    const {
      currentPage,
      pageType,
      sortBy,
      automotive
    } = getState() || {};
    const {
      formattedIndexes
    } = automotive || {};
    const ddoEvent = {
      eventInfo: {
        eventName: 'filter by'
      },
      category: {
        primaryCategory: pageType
      },
      filter: [{
        selectionMethod: 'default',
        type: 'automotive fit type',
        value: 'universal',
        position: formattedIndexes
      }],
      displayAttributes: {
        viewType: 'grid',
        pageNumber: currentPage,
        productsAvailability: 'all products',
        sortBy
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });
  window.LIFE_CYCLE_EVENT_BUS.on('car-picker.dont-see-vehicle', () => {
    var _getState3;
    const {
      formattedYearMakeModelAlt
    } = ((_getState3 = getState()) === null || _getState3 === void 0 ? void 0 : _getState3.automotive) || {};
    const ddoEvent = {
      category: {
        primaryCategory: 'stash'
      },
      eventInfo: {
        eventName: 'widget interaction'
      },
      eventMode: 'stash',
      content: {
        widget: {
          type: 'auto',
          value: formattedYearMakeModelAlt || 'no selection'
        }
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });
  window.LIFE_CYCLE_EVENT_BUS.on('car-picker.page-load', _ref2 => {
    var _getState4, _getState4$automotive;
    let {
      output
    } = _ref2;
    if (Object.keys(output).length > 0) {
      const {
        year,
        yearIndex,
        make,
        makeIndex,
        model,
        modelIndex
      } = output;
      const data = {
        year,
        yearIndex,
        make,
        makeIndex,
        model,
        modelIndex
      };
      const formattedYearMakeModel = formatCarPickerString([year, make, model], ' ');
      const formattedYearMakeModelAlt = formatCarPickerString([year, make, model], '>');
      const formattedIndexes = formatCarPickerString([yearIndex, makeIndex, modelIndex], ':');
      setState({
        automotive: {
          data,
          formattedYearMakeModel,
          formattedYearMakeModelAlt,
          formattedIndexes
        }
      });
    }
    const ddoEvent = {
      content: {
        widget: {
          type: 'auto',
          value: ((_getState4 = getState()) === null || _getState4 === void 0 ? void 0 : (_getState4$automotive = _getState4.automotive) === null || _getState4$automotive === void 0 ? void 0 : _getState4$automotive.formattedYearMakeModelAlt) || 'no selection'
        }
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });
};
//# sourceMappingURL=car-picker.listener.analytics.js.map